module.exports = __webpack_public_path__ + "img/Postnatal.d018abff.png";